import 'classlist-polyfill';

//customEvent polyfill
(() => {
  if ( typeof window.CustomEvent === 'function' ) {
    return false;
  }

  function CustomEvent( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    let evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

//forEach polyfill
(() => {
  if ( 'NodeList' in window && !NodeList.prototype.forEach ) {
    NodeList.prototype.forEach = function( callback, thisArg ) {
      thisArg = thisArg || window;
      for ( let i = 0; i < this.length; i++ ) {
        callback.call( thisArg, this[ i ], i, this );
      }
    };
  }
})();
